import React from 'react';
import hoistNonReactStatics from 'hoist-non-react-statics';

import useConfig from './configHooks';

const withConfig = (WrappedComponent) => {
  const HOC = (props) => {
    const { forwardedRef, ...restProps } = props;
    const config = useConfig();
    return <WrappedComponent {...restProps} appConfig={config} ref={forwardedRef} />;
  };

  hoistNonReactStatics(HOC, WrappedComponent);

  return HOC;
};

export default withConfig;
